const getTravelType = ({ source, destination, travelType }) => {
  let tt = '';
  if (!source || !destination) {
    return tt;
  }
  if (source.cc === 'IN' && destination.cc === 'IN' && travelType !== 'domestic') {
    tt = 'domestic';
  } else if ((source.cc !== 'IN' || destination.cc !== 'IN') && travelType === 'domestic') {
    tt = 'international';
  }
  return tt;
};

export default getTravelType;
